module.exports = __webpack_public_path__ + "static/media/calamityroseranch.de0f0ef5.png";